var _rect, _path, _path2, _rect2, _rect3, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalhaFantasia1Bloq({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 260,
    viewBox: "0 0 214 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 213,
    height: 260,
    rx: 8,
    fill: "#ECE6F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.682 112.951C170.682 152.752 142.821 172.653 109.706 184.196C107.972 184.783 106.089 184.755 104.373 184.116C71.1786 172.653 43.3175 152.752 43.3175 112.951V57.2286C43.3175 55.1174 44.1562 53.0927 45.649 51.5998C47.1419 50.107 49.1666 49.2683 51.2778 49.2683C67.1984 49.2683 87.0992 39.7159 100.95 27.6163C102.637 26.1754 104.782 25.3838 107 25.3838C109.218 25.3838 111.363 26.1754 113.05 27.6163C126.98 39.7955 146.802 49.2683 162.722 49.2683C164.833 49.2683 166.858 50.107 168.351 51.5998C169.844 53.0927 170.682 55.1174 170.682 57.2286V112.951Z",
    fill: "url(#paint0_linear_2162_31049)",
    stroke: "url(#paint1_linear_2162_31049)",
    strokeWidth: 3.91429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.548 81.5L90 115.892L98.7167 124.406L132.264 90.0137L130.009 82.5206L123.548 81.5Z",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88.303,
    y: 81.5,
    width: 45.421,
    height: 13,
    transform: "rotate(45.6935 88.303 81.5)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7065,
    y: 85.9863,
    width: 45.421,
    height: 6.57683,
    transform: "rotate(45.6935 83.7065 85.9863)",
    fill: "#C0C0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.8 123.7L81.6001 91.4996V83.0996H90.0001L122.2 115.3M109.6 127.9L126.4 111.1M118 119.5L129.2 130.7M126.4 133.5L132 127.9M113.8 92.8997L123.6 83.0996H132V91.4996L122.2 101.3M87.2001 113.9L101.2 127.9M92.8001 122.3L84.4001 130.7M81.6001 127.9L87.2001 133.5",
    stroke: "#C0C0C0",
    strokeWidth: 5.60002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94 127.61V123.5C94 119.92 95.4223 116.486 97.9541 113.954C100.486 111.422 103.92 110 107.5 110C111.08 110 114.514 111.422 117.046 113.954C119.578 116.486 121 119.92 121 123.5V127.61C123.23 127.776 124.68 128.196 125.742 129.258C127.5 131.014 127.5 133.844 127.5 139.5C127.5 145.156 127.5 147.986 125.742 149.742C123.986 151.5 121.156 151.5 115.5 151.5H99.5C93.844 151.5 91.014 151.5 89.258 149.742C87.5 147.986 87.5 145.156 87.5 139.5C87.5 133.844 87.5 131.014 89.258 129.258C90.318 128.196 91.77 127.776 94 127.61ZM97 123.5C97 120.715 98.1062 118.045 100.075 116.075C102.045 114.106 104.715 113 107.5 113C110.285 113 112.955 114.106 114.925 116.075C116.894 118.045 118 120.715 118 123.5V127.508C117.235 127.501 116.401 127.499 115.5 127.5H99.5C98.5973 127.499 97.764 127.501 97 127.508V123.5ZM107.5 134C107.898 134 108.279 134.158 108.561 134.439C108.842 134.721 109 135.102 109 135.5V143.5C109 143.898 108.842 144.279 108.561 144.561C108.279 144.842 107.898 145 107.5 145C107.102 145 106.721 144.842 106.439 144.561C106.158 144.279 106 143.898 106 143.5V135.5C106 135.102 106.158 134.721 106.439 134.439C106.721 134.158 107.102 134 107.5 134Z",
    fill: "#8E58BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0327 207.253V227.616H79.2088L68.858 212.682H68.669V227.616H65.5966V207.253H68.4403L78.8011 222.207H78.9901V207.253H82.0327ZM86.2759 227.616V212.343H89.2489V227.616H86.2759ZM86.5543 210.305L88.881 205.721H92.0131L88.9308 210.305H86.5543ZM106.314 212.343L100.776 227.616H97.5938L92.0455 212.343H95.2372L99.1051 224.096H99.2642L103.122 212.343H106.314ZM115.171 227.924C113.666 227.924 112.37 227.603 111.283 226.96C110.203 226.31 109.367 225.399 108.777 224.226C108.194 223.046 107.902 221.664 107.902 220.079C107.902 218.515 108.194 217.136 108.777 215.943C109.367 214.75 110.189 213.818 111.243 213.149C112.304 212.479 113.543 212.145 114.962 212.145C115.824 212.145 116.659 212.287 117.468 212.572C118.276 212.857 119.002 213.305 119.645 213.915C120.288 214.524 120.795 215.316 121.167 216.291C121.538 217.259 121.723 218.435 121.723 219.821V220.875H109.583V218.647H118.81C118.81 217.865 118.651 217.173 118.333 216.569C118.015 215.959 117.567 215.479 116.99 215.128C116.42 214.776 115.751 214.601 114.982 214.601C114.147 214.601 113.417 214.806 112.794 215.217C112.178 215.621 111.701 216.152 111.363 216.808C111.031 217.458 110.865 218.164 110.865 218.926V220.666C110.865 221.687 111.044 222.555 111.402 223.271C111.767 223.987 112.274 224.534 112.924 224.912C113.573 225.283 114.332 225.468 115.201 225.468C115.764 225.468 116.278 225.389 116.742 225.23C117.206 225.064 117.607 224.819 117.945 224.494C118.283 224.169 118.542 223.768 118.721 223.291L121.534 223.798C121.309 224.627 120.905 225.352 120.321 225.976C119.745 226.592 119.019 227.073 118.144 227.417C117.275 227.755 116.284 227.924 115.171 227.924ZM127.995 207.253V227.616H125.022V207.253H127.995ZM147.091 207.253V227.616H144.009V210.335H143.889L139.017 213.517V210.574L144.098 207.253H147.091Z",
    fill: "#C0C0C0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_31049",
    x1: 107,
    y1: 25.3838,
    x2: 107,
    y2: 184.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECE6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536865,
    stopColor: "#ECE6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECE6F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_31049",
    x1: 107,
    y1: 25.3838,
    x2: 107,
    y2: 184.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalhaFantasia1Bloq);
export default __webpack_public_path__ + "static/media/Medalha_fantasia_1_bloq.8d4ca47d158a9b8f0836cd1f22e417d7.svg";
export { ForwardRef as ReactComponent };